export const ROUTE_REGISTRATION = '/register';
export const ROUTE_FACEBOOK_REDIRECT_HANDLER = '/auth/facebook_redirect';
